import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import HistoryIcon from '@mui/icons-material/History';

import PeopleIcon from "@mui/icons-material/People";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_CLIENT_ID } from "../../graphQL/term_applicant_qry";


import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ApplicationList() {  
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [isViaForm, setIsViaForm] = useState(true);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);

  const [termApplicantList, setTermApplicantList] = useState([]);
  
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  let applicantId = 0;
  if(localStorage.getItem("applicantId"))
    applicantId = localStorage.getItem("applicantId");
  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  
  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  
  const [fetchTermApplicantList] = useManualQuery(GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_CLIENT_ID, {
    fetchPolicy: "network-only",
  }); 
 
  
  const getTermApplicantList = async () => {
    const {
      loading: applicationsListLoading,
      error: applicationsListError,
      data: applicationsListData,
    } = await fetchTermApplicantList({
        variables: {
          applicantId: parseInt(applicantId),
          clientId: parseInt(clientId)          
        },
      });

    if (!applicationsListLoading && 
        applicationsListData && 
        applicationsListData.getAllTermApplicantsByApplicantIdClientId) {
     
      setTermApplicantList(applicationsListData.getAllTermApplicantsByApplicantIdClientId);
      setIsViaForm(applicationsListData.getAllTermApplicantsByApplicantIdClientId.length > 0 ? 
      applicationsListData.getAllTermApplicantsByApplicantIdClientId[0].applicantId.viaForm : true);
      setLoadData(true);
    }
  };

  
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermApplicantList())();
  }, []);

  
  
  const columns = [
    {
      field: "termName",
      headerName: "Term Name",
      minWidth: 170,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "termPeriod",
      headerName: "Term Period",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "applicationDate",
      headerName: isViaForm ? "Application Date" : "Onboarded Date",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "applicationStatus",
      headerName: "Application Status",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "applicantStatus",
      headerName: "Applicant Status",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            
            <StyledTooltip 
              title={rows.row.viaForm ? "View Application" : "No Application"}
            >
              <span style={{ display: "inline-flex" }}>
                <IconButton
                  style={{ padding: 0 }}
                  disabled={!rows.row.viaForm}
                >
                  <img                
                    src={previewImg}
                    style={{
                      opacity: rows.row.viaForm ? 1 : 0.6,
                    }}
                    onClick={() => {
                      if (rows.row.viaForm) {
                        navigate(`${project_url}/applicant/${rows.row.termUuid}/application-view`)
                      }
                    }}
                  />
                </IconButton>
              </span>
            </StyledTooltip>

            <Box pr={2} />
            
            <StyledTooltip title="Activity Log">
              <IconButton style={{ padding: 0 }}>
                <HistoryIcon />               
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  var rows = termApplicantList.map(application => ({
    id: application.termApplicantId,    
    termName: application.termId.name,
    termPeriod: application.termId.period,
    termUuid: application.termId.termUuid,
    applicationDate: dayFormat(application.createDate),
    applicationStatus: application.applicationStatus,
    applicantStatus: application.applicantStatus,
    viaForm: application.applicantId.viaForm,

  }));

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Applications
            </Typography>
          </Grid>
         
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent && loadData)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Applications List", link: null }]} />
        <div className={classes.container} style={{marginTop: 21}}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
          />

          
          
        </div>
      </div>
    );
  else return;
}

export default ApplicationList;
